/** 成本统计相关 API (复用后端 /api/stats/*)
 *
 * 角色隔离由后端负责 (prices_main.py stats_*):
 *   user          → daily / monthly / by-model 只含自己的数据
 *   company_admin → 本公司；另可调 by-user (本公司)
 *   super_admin   → 全部；另可调 by-user (全部) / by-company
 */
import { apiFetch } from "@/lib/api-client";

/** 各统计查询共有的聚合列 (stats_db.query_*_scoped) */
export interface UsageTotals {
  /** API 请求次数 = COUNT(*) */
  requests: number;
  user_queries: number;
  input_tokens: number;
  output_tokens: number;
  total_tokens: number;
  image_count: number;
}

export interface DailyStatRow extends UsageTotals {
  date: string;
}

export interface MonthlyStatRow extends UsageTotals {
  month: string;
}

export interface ByModelRow extends UsageTotals {
  /** 旧数据可能没有记录模型 */
  model: string | null;
}

export interface ByUserRow extends UsageTotals {
  user_id: number;
  username: string;
  display_name: string;
  role: string;
}

export interface ByCompanyRow extends UsageTotals {
  company_id: number;
  company_name: string;
}

export interface DailyResp { month: string; data: DailyStatRow[] }
export interface MonthlyResp { data: MonthlyStatRow[] }
export interface ByModelResp { month: string; data: ByModelRow[] }
export interface ByUserResp { month: string; data: ByUserRow[] }
export interface ByCompanyResp { month: string; data: ByCompanyRow[] }

export async function fetchDaily(month: string): Promise<DailyResp> {
  return apiFetch<DailyResp>(`/api/stats/daily?month=${encodeURIComponent(month)}`);
}

export async function fetchMonthly(months = 12): Promise<MonthlyResp> {
  return apiFetch<MonthlyResp>(`/api/stats/monthly?months=${months}`);
}

export async function fetchByModel(month: string): Promise<ByModelResp> {
  return apiFetch<ByModelResp>(`/api/stats/by-model?month=${encodeURIComponent(month)}`);
}

/** company_admin / super_admin */
export async function fetchByUser(month: string): Promise<ByUserResp> {
  return apiFetch<ByUserResp>(`/api/stats/by-user?month=${encodeURIComponent(month)}`);
}

/** 仅 super_admin */
export async function fetchByCompany(month: string): Promise<ByCompanyResp> {
  return apiFetch<ByCompanyResp>(`/api/stats/by-company?month=${encodeURIComponent(month)}`);
}
